// src/pages/public/home/HomePage.js
import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import HeroSection from '../../../components/public/common/HeroSection';
import WhoWeAreSection from '../../../components/public/common/WhoWeAreSection';
import WhyChooseUsSection from '../../../components/public/common/WhyChooseUsSection';
import FeaturedProjects from '../../../components/public/common/FeaturedProjects';
import TestimonialSection from '../../../components/public/common/TestimonialSection';
import ServicesSection from '../../../components/public/common/ServicesSection';
import ToolsWeUseSection from '../../../components/public/common/ToolsWeUseSection';
import NewsletterSection from '../../../components/public/common/NewsletterSection';
import FeaturedCaseStudies from '../../../components/public/common/FeaturedCaseStudies';
import ContactCTA from '../../../components/public/common/ContactCTA';
import BlogSection from '../../../components/public/common/BlogSection';
import Layout from '../../../components/public/common/Layout';
import TechLoader from '../../../components/common/TechLoader';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    // Simulate initial data loading
    const loadData = async () => {
      try {
        // Add your actual data loading logic here
        await new Promise(resolve => setTimeout(resolve, 1500)); // Simulated delay
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <TechLoader size="xl" text="Loading amazing content..." />
      </div>
    );
  }

  // Define base section themes
  const baseSectionThemes = {
    hero: 'dark',
    whoWeAre: 'light',
    whyChooseUs: 'dark',
    featuredProjects: 'light',
    featuredCaseStudies: 'dark',
    services: 'light',
    testimonials: 'dark',
    tools: 'light',
    blog: 'dark',
    newsletter: 'light',
    contact: 'dark'
  };

  // Toggle themes if global theme is dark
  const sectionThemes = theme === 'dark'
    ? Object.fromEntries(
        Object.entries(baseSectionThemes).map(([key, value]) => [
          key,
          value === 'dark' ? 'light' : 'dark'
        ])
      )
    : baseSectionThemes;

  return (
    <Layout>
      <HeroSection theme={sectionThemes.hero} />
      <WhoWeAreSection theme={sectionThemes.whoWeAre} />
      <WhyChooseUsSection theme={sectionThemes.whyChooseUs} /> 
      <FeaturedProjects theme={sectionThemes.featuredProjects} />
      <FeaturedCaseStudies theme={sectionThemes.featuredCaseStudies} />
      <ServicesSection theme={sectionThemes.services} />
      <TestimonialSection theme={sectionThemes.testimonials} />
      <ToolsWeUseSection theme={sectionThemes.tools} />
      <BlogSection theme={sectionThemes.blog} />
      <NewsletterSection theme={sectionThemes.newsletter} />
      <ContactCTA theme={sectionThemes.contact} />
    </Layout>
  );
};

export default HomePage;
